/* ZNS Shader Background v7 - gold plasma on desktop AND mobile, softer gold.
   Loads BEFORE zns-universe.js and claims the stage so the starfield IIFE bails out. */
(function () {
  'use strict';
  if (window.__znsUniverse) return;
  window.__znsUniverse = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  var isMobile = window.matchMedia('(max-width: 767px)').matches || (coarse && (navigator.maxTouchPoints || 0) > 0);
  var lowMem = (navigator.deviceMemory || 8) <= 3;

  var VS = [
    'attribute vec4 aVertexPosition;',
    'void main(){ gl_Position = aVertexPosition; }'
  ].join('\n');

  var FS = [
    'precision highp float;',
    'uniform vec2 iResolution;',
    'uniform float iTime;',
    'const float overallSpeed = 0.2;',
    'const float gridSmoothWidth = 0.015;',
    'const float scale = 5.0;',
    'const vec4 lineColor = vec4(0.91, 0.698, 0.227, 1.0);',
    'const float minLineWidth = 0.01;',
    'const float maxLineWidth = 0.2;',
    'const float lineSpeed = 1.0 * overallSpeed;',
    'const float lineAmplitude = 1.0;',
    'const float lineFrequency = 0.2;',
    'const float warpSpeed = 0.2 * overallSpeed;',
    'const float warpFrequency = 0.5;',
    'const float warpAmplitude = 1.0;',
    'const float offsetFrequency = 0.5;',
    'const float offsetSpeed = 1.33 * overallSpeed;',
    'const float minOffsetSpread = 0.6;',
    'const float maxOffsetSpread = 2.0;',
    'const int linesPerGroup = 10;',
    '#define drawCircle(pos, radius, coord) smoothstep(radius + gridSmoothWidth, radius, length(coord - (pos)))',
    '#define drawSmoothLine(pos, halfWidth, t) smoothstep(halfWidth, 0.0, abs(pos - (t)))',
    '#define drawCrispLine(pos, halfWidth, t) smoothstep(halfWidth + gridSmoothWidth, halfWidth, abs(pos - (t)))',
    'float random(float t){ return (cos(t) + cos(t * 1.3 + 1.3) + cos(t * 1.4 + 1.4)) / 3.0; }',
    'float getPlasmaY(float x, float horizontalFade, float offset){ return random(x * lineFrequency + iTime * lineSpeed) * horizontalFade * lineAmplitude + offset; }',
    'void main(){',
    '  vec2 fragCoord = gl_FragCoord.xy;',
    '  vec4 fragColor;',
    '  vec2 uv = fragCoord.xy / iResolution.xy;',
    '  vec2 space = (fragCoord - iResolution.xy / 2.0) / iResolution.x * 2.0 * scale;',
    '  float horizontalFade = 1.0 - (cos(uv.x * 6.28) * 0.5 + 0.5);',
    '  float verticalFade = 1.0 - (cos(uv.y * 6.28) * 0.5 + 0.5);',
    '  space.y += random(space.x * warpFrequency + iTime * warpSpeed) * warpAmplitude * (0.5 + horizontalFade);',
    '  space.x += random(space.y * warpFrequency + iTime * warpSpeed + 2.0) * warpAmplitude * horizontalFade;',
    '  vec4 lines = vec4(0.0);',
    '  vec4 bgColor1 = vec4(0.047, 0.039, 0.035, 1.0);',
    '  vec4 bgColor2 = vec4(0.13, 0.085, 0.045, 1.0);',
    '  for(int l = 0; l < linesPerGroup; l++){',
    '    float normalizedLineIndex = float(l) / float(linesPerGroup);',
    '    float offsetTime = iTime * offsetSpeed;',
    '    float offsetPosition = float(l) + space.x * offsetFrequency;',
    '    float rand = random(offsetPosition + offsetTime) * 0.5 + 0.5;',
    '    float halfWidth = mix(minLineWidth, maxLineWidth, rand * horizontalFade) / 2.0;',
    '    float offset = random(offsetPosition + offsetTime * (1.0 + normalizedLineIndex)) * mix(minOffsetSpread, maxOffsetSpread, horizontalFade);',
    '    float linePosition = getPlasmaY(space.x, horizontalFade, offset);',
    '    float line = drawSmoothLine(linePosition, halfWidth, space.y) / 2.0 + drawCrispLine(linePosition, halfWidth * 0.15, space.y);',
    '    float circleX = mod(float(l) + iTime * lineSpeed, 25.0) - 12.0;',
    '    vec2 circlePosition = vec2(circleX, getPlasmaY(circleX, horizontalFade, offset));',
    '    float circle = drawCircle(circlePosition, 0.01, space) * 4.0;',
    '    line = line + circle;',
    '    lines += line * lineColor * rand;',
    '  }',
    '  fragColor = mix(bgColor1, bgColor2, uv.x);',
    '  fragColor *= verticalFade;',
    '  fragColor.a = 1.0;',
    '  fragColor += lines * 0.7;',
    '  gl_FragColor = fragColor;',
    '}'
  ].join('\n');

  function startStarfield(stage) {
    if (stage.querySelector('canvas')) return;
    stage.insertAdjacentHTML('afterbegin', '<canvas></canvas><div class="zns-blob zns-b1"></div><div class="zns-blob zns-b2"></div><div class="zns-blob zns-b3"></div>');
    var cv = stage.querySelector('canvas');
    var ctx = cv.getContext('2d');
    var stars = [], shoot = null, nextShoot = performance.now() + 4000, W, H;
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      W = window.innerWidth; H = window.innerHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.min(160, Math.round(W * H / 11000));
      stars = [];
      for (var i = 0; i < n; i++) {
        stars.push({ x: Math.random() * W, y: Math.random() * H, z: 0.3 + Math.random() * 0.7, r: 0.4 + Math.random() * 1.3, a: 0.25 + Math.random() * 0.55, tw: 0.5 + Math.random() * 1.6, ph: Math.random() * 6.28, gold: Math.random() < 0.14 });
      }
    }
    size();
    window.addEventListener('resize', size);
    function draw(t) {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.x -= 0.018 * s.z; if (s.x < -2) s.x = W + 2;
        var tw = 0.62 + 0.38 * Math.sin(t / 1000 * s.tw + s.ph);
        ctx.globalAlpha = s.a * tw;
        ctx.fillStyle = s.gold ? '#F2C457' : '#FAFAF9';
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r * s.z, 0, 6.28); ctx.fill();
      }
      if (!shoot && t > nextShoot) { shoot = { x: W * (0.2 + Math.random() * 0.7), y: H * Math.random() * 0.4, vx: -(6 + Math.random() * 4), vy: 2.4 + Math.random() * 1.6, life: 1 }; }
      if (shoot) {
        shoot.x += shoot.vx; shoot.y += shoot.vy; shoot.life -= 0.022;
        var g = ctx.createLinearGradient(shoot.x, shoot.y, shoot.x - shoot.vx * 9, shoot.y - shoot.vy * 9);
        g.addColorStop(0, 'rgba(250,250,249,' + (0.85 * shoot.life) + ')');
        g.addColorStop(1, 'rgba(250,250,249,0)');
        ctx.strokeStyle = g; ctx.lineWidth = 1.6; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(shoot.x, shoot.y); ctx.lineTo(shoot.x - shoot.vx * 9, shoot.y - shoot.vy * 9); ctx.stroke();
        if (shoot.life <= 0 || shoot.x < -60 || shoot.y > H + 60) { shoot = null; nextShoot = t + 5000 + Math.random() * 6000; }
      }
      ctx.globalAlpha = 1;
      if (!document.hidden) requestAnimationFrame(draw);
    }
    requestAnimationFrame(draw);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) requestAnimationFrame(draw); });
  }

  function relaxBlur() {
    var st = document.createElement('style');
    st.textContent = 'html .card{backdrop-filter:none !important;-webkit-backdrop-filter:none !important;background:rgba(20,17,15,.86) !important;} html .header-wrapper{backdrop-filter:blur(8px) !important;-webkit-backdrop-filter:blur(8px) !important;}';
    document.head.appendChild(st);
  }

  function startShader(stage) {
    var cv = document.createElement('canvas');
    stage.insertBefore(cv, stage.firstChild);
    var gl = null;
    try { gl = cv.getContext('webgl', { alpha: false, antialias: false, depth: false, stencil: false, powerPreference: 'low-power' }) || cv.getContext('experimental-webgl'); } catch (e) { gl = null; }
    if (!gl) { cv.remove(); return false; }
    var raf = null, lost = false;
    cv.addEventListener('webglcontextlost', function (e) { e.preventDefault(); lost = true; if (raf) cancelAnimationFrame(raf); cv.remove(); startStarfield(stage); }, false);
    function sh(type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) return null; return s; }
    var vsh = sh(gl.VERTEX_SHADER, VS), fsh = sh(gl.FRAGMENT_SHADER, FS);
    if (!vsh || !fsh) { cv.remove(); return false; }
    var prog = gl.createProgram(); gl.attachShader(prog, vsh); gl.attachShader(prog, fsh); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { cv.remove(); return false; }
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var aPos = gl.getAttribLocation(prog, 'aVertexPosition');
    var uRes = gl.getUniformLocation(prog, 'iResolution');
    var uTime = gl.getUniformLocation(prog, 'iTime');
    var RES = isMobile ? 0.5 : 0.62;
    function size() { cv.width = Math.max(1, Math.round(window.innerWidth * RES)); cv.height = Math.max(1, Math.round(window.innerHeight * RES)); gl.viewport(0, 0, cv.width, cv.height); }
    size();
    window.addEventListener('resize', size);
    gl.useProgram(prog); gl.bindBuffer(gl.ARRAY_BUFFER, buf); gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0); gl.enableVertexAttribArray(aPos);
    var t0 = performance.now(), last = 0, interval = 1000 / (isMobile ? 30 : 40);
    function frame(now) {
      if (lost || document.hidden) { raf = null; return; }
      raf = requestAnimationFrame(frame);
      if (now - last < interval) return;
      last = now;
      gl.uniform2f(uRes, cv.width, cv.height);
      gl.uniform1f(uTime, (now - t0) / 1000);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    raf = requestAnimationFrame(frame);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && !lost && raf === null) { last = 0; raf = requestAnimationFrame(frame); } });
    relaxBlur();
    return true;
  }

  function init() {
    var stage = document.createElement('div');
    stage.className = 'zns-stage';
    stage.setAttribute('aria-hidden', 'true');
    stage.innerHTML = '<div class="zns-floor"></div>';
    document.body.insertBefore(stage, document.body.firstChild);
    if (reduced) return;
    if (lowMem) { startStarfield(stage); return; }
    if (!startShader(stage)) startStarfield(stage);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
